export default "__VITE_ASSET__D$tcAvoK__"